export const NodeEnv = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
  TEST: 'test'
};
